/* eslint-disable react/prop-types */
import React, { useState, useCallback, useEffect, useRef } from 'react'
import GoogleMapReact from 'google-map-react'
import PropTypes from 'prop-types'
import { REACT_APP_GOOGLE_API_KEY } from '../../config/env'
import {
  PathIcon,
  FlagIcon,
  MinusIcon,
  PlusIcon,
  CurrentLocationIcon,
} from '../svg.common'
import { MarkerWrapper, MapWrapper } from './googlemap.styles'
import Color from '../../constants/color.constants'
import { HomeOutlined } from '@ant-design/icons'

export const Marker = (props) => {
  const { logo, isRider, icon, children, logoVisible } = props

  if (isRider) {
    return (
      <MarkerWrapper>
        <div className="path">
          <img
            alt="pin"
            className="dailyrunner"
            src="/assets/images/icon/dailyrunner-pin.png"
          />
        </div>
      </MarkerWrapper>
    )
  }

  return (
    <MarkerWrapper>
      <div className="path">
        <PathIcon />
        {icon ? (
          <img className={logo ? 'logo-pin' : ''} src={icon} alt="pin" />
        ) : (
          <FlagIcon className="flag-icon" />
        )}
        <div style={{ display: logoVisible ? 'block' : 'none' }}>{children}</div>
      </div>
    </MarkerWrapper>
  )
}

Marker.defaultProps = {
  logo: '',
  icon: '',
  isRider: false,
  children: <></>,
  logoVisible: false,
}

Marker.propTypes = {
  logo: PropTypes.string,
  icon: PropTypes.string,
  isRider: PropTypes.bool,
  children: PropTypes.node,
  logoVisible: PropTypes.bool,
}

const GooglemapCommon = (props) => {
  // console.log(props)
  const {
    zoom,
    onSetCenter,
    children,
    onChange,
    className,
    searchBox,
    searchBoxPlaceholder,
    onPlacesChanged,
    status,
    restatusFunc,
    foundLocationnewUser,
    loadingGetlocation,
  } = props
  console.log(loadingGetlocation)
  const [map, setMap] = useState()
  const [maps, setMaps] = useState()
  const [center, setCenter] = useState(props.center)
  const [statusLoading, setStatusLoading] = useState(false)

  useEffect(async () => {
    console.log('เข้า useeffect')
    // await onCurrentLocation()
    onSetCenter(center)
  }, [center])

  // useEffect(() => {
  //   console.log('เข้า useeffect = oncur')
  //   onCurrentLocation()
  // }, [foundLocationnewUser])

  const [apiLoaded, setApiLoaded] = useState(false)

  const SearchBox = (props) => {
    const { map, maps, placeholder } = props
    const input = useRef(null)
    const searchBox = useRef(null)

    // const handleOnPlacesChanged = useCallback(() => {
    //   console.log('เข้า -> handleOnplaceChanged')
    //   if (onPlacesChanged) {
    //     const places = searchBox.current?.getPlaces()
    //     onPlacesChanged({ map, maps, places })
    //   }
    // }, [map, maps])

    useEffect(() => {
      if (!searchBox.current && maps) {
        searchBox.current = new maps.places.SearchBox(input.current)
        searchBox.current.addListener('places_changed', handleOnPlacesChanged)
      }

      return () => {
        if (maps) {
          searchBox.current = null
          maps.event.clearInstanceListeners(searchBox)
        }
      }
    }, [maps, handleOnPlacesChanged, map])

    return (
      <input
        className="form-control"
        ref={input}
        placeholder={placeholder}
        type="text"
        style={{
          position: 'absolute',
          zIndex: '1',
          width: 'calc(100% - 20px)',
          height: '45px',
          top: '10px',
          left: '50%',
          borderRadius: '22px',
          border: `1px solid ${Color.primary}`,
          transform: 'translateX(-50%)',
          outline: 0,
          padding: '10px',
        }}
      />
    )
  }

  SearchBox.defaultProps = {
    map: '',
    maps: '',
    placeholder: '',
  }

  SearchBox.propTypes = {
    map: PropTypes.shape({}),
    maps: PropTypes.shape({}),
    placeholder: PropTypes.string,
  }

  const onCurrentLocation = useCallback(() => {
    console.log('เข้า -> onCurrentLocation')
    loadingGetlocation(true)
    // foundLocationnewUser(false)
    // FoundLocationnewUser(false)
    if (!navigator.geolocation || !map) return
    navigator.geolocation.getCurrentPosition((position) => {
      // console.log(position)
      setCenter({
        lat: position.coords.latitude,
        lng: position.coords.longitude,
      })
    })
  }, [map])
  // useEffect(() => {
  //   onCurrentLocation()
  // }, [foundLocationnewUser])

  // console.log(foundLocationnewUser)

  const onLoad = ({ map, maps }) => {
    setMap(map)
    setMaps(maps)
    setApiLoaded(true)
  }
  // const onClick = (e) => setCenter(e)
  const onClick = (e) => {
    setCenter(e)
    // console.log(e)
    restatusFunc(false)
  }

  return (
    <MapWrapper className={className}>
      <div className="map-frame">
        {apiLoaded && searchBox && (
          <SearchBox map={map} maps={maps} placeholder={searchBoxPlaceholder} />
        )}
        <GoogleMapReact
          yesIWantToUseGoogleMapApiInternals
          bootstrapURLKeys={{
            key: REACT_APP_GOOGLE_API_KEY,
            libraries: ['places'],
          }}
          defaultCenter={CurrentLocationIcon}
          defaultZoom={zoom}
          center={props.center ? props.center : center}
          onClick={onClick}
          onChange={() => onChange({ map, maps })}
          options={{
            zoomControl: false,
            fullscreenControl: false,
          }}
          onGoogleApiLoaded={onLoad}
          style={{
            width: '100%',
            height: '100%',
            padding: '10px',
            position: 'initial',
          }}
        >
          {children || <Marker {...center} />}
        </GoogleMapReact>
        <div className="control-panal">
          <div className="zoom-group-btn">
            <div
              className="zoom-in-btn map-btn"
              onClick={() => map?.setZoom(map?.getZoom() + 1)}
            >
              <PlusIcon />
            </div>
            <div
              className="zoom-out-btn map-btn"
              onClick={() => map?.setZoom(map?.getZoom() - 1)}
            >
              <MinusIcon />
            </div>
          </div>
          <div className="current-location map-btn" onClick={onCurrentLocation}>
            {/* <CurrentLocationIcon /> */}
            <HomeOutlined className="icon-color-tyle-darkgrey" />
          </div>
        </div>
      </div>
    </MapWrapper>
  )
}

GooglemapCommon.defaultProps = {
  center: {
    lat: null,
    lng: null,
  },
  zoom: 15,
  onChange: () => {},
  className: '',
  onPlacesChanged: () => {},
  searchBox: false,
  searchBoxPlaceholder: 'ค้นหาด้วย Google Map',
  children: <></>,
}

GooglemapCommon.propTypes = {
  center: PropTypes.shape({
    lat: PropTypes.number,
    lng: PropTypes.number,
  }),
  zoom: PropTypes.number,
  onChange: PropTypes.func,
  className: PropTypes.string,
  onPlacesChanged: PropTypes.func,
  searchBox: PropTypes.bool,
  searchBoxPlaceholder: PropTypes.string,
  children: PropTypes.node,
}

export default GooglemapCommon
